import PosthogService from '~/services/posthog/PosthogService';
import { type IShiftRequestMissingInfoPayload } from './missingInfoPopupViewed';

/**
 * Fires when an office taps Save on the missing office details modal with a valid form, before
 * the save result is known (GOTU-12579). `funnelEntryId` is attached automatically.
 * Event: dental_portal:missing_info_popup:info_submitted
 */
export function fireShiftRequestMissingInfoSubmitted(
  payload: IShiftRequestMissingInfoPayload,
): void {
  PosthogService.getInstance().track('dental_portal:missing_info_popup:info_submitted', {
    profession_type: payload.professionType,
    missing_fields: payload.missingFields,
  });
}
